import api from "./api";

const admissionService = {
    getStats: (params) => api.get("/admissions/stats", { params }),
    getAll: (params) => api.get("/admissions", { params }),
    getById: (id) => api.get(`/admissions/${id}`),
    create: (data) => api.post("/admissions", data),
    update: (id, data) => api.put(`/admissions/${id}`, data),
    moveToStage: (id, data) => api.patch(`/admissions/${id}/stage`, data),
    remove: (id) => api.delete(`/admissions/${id}`),
};

export default admissionService;
